<template>
    <v-dialog v-model="dialog" width="1200px">
        <v-card>
            <v-form ref="copyHsft" v-model="copyHsftValid">
            <v-card-title class="justify-center">Bulk copy of photo's {{ huis.huis_code }}</v-card-title>
            <v-divider/>
            <div class="scrollable">
                <v-row no-gutters>
                    <v-col v-for="p in huis.hsft_aant" :key="p" id="content" class="pa-2" cols=2>
                        <figure>
                            <figcaption>&nbsp; {{ huis.hsft[parseInt(p) - 1].hsft_nr }}</figcaption>
                            <img :src="huis.hsft[parseInt(p) - 1].hsft_foto" class="px-1" :title="huis.hsft[parseInt(p) - 1].hsft_tag">
                            <v-checkbox v-model="selected" :value="huis.hsft[parseInt(p) - 1].hsft_encrid" :rules="selected_checks" label="Copy" class="my-0"></v-checkbox> 
                        </figure>                         
                    </v-col>
                </v-row>
            </div>
            <v-row no-gutters>
                <v-col class="pa-2">
                    <v-autocomplete
                        v-model="to_huis_code"
                        :items="items"
                        :loading="isLoading"
                        :search-input.sync="search"
                        :rules="to_huis_code_checks"
                        cache-items
                        filled
                        chips
                        color="blue-grey lighten-2"
                        label="Start typing accommodation code (search starts after 3 characters)"
                        item-text="huis_code"
                        item-value="huis_code"
                        dense
                        required
                        >
                        <template v-slot:selection="data">
                            <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close
                            @click="data.select"
                            @click:close="remove(data.item)"
                            >
                            <v-icon left>
                                mdi-home
                            </v-icon>
                            {{ data.item.huis_code }}
                            </v-chip>
                        </template>
                        <template v-slot:item="data">
                            <v-list-item-avatar>
                            <v-icon left>
                                mdi-home
                            </v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                            <v-list-item-title v-text="data.item.huis_code"></v-list-item-title>
                            <v-list-item-subtitle v-text="data.item.huis_naam"></v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
            </v-autocomplete>
                </v-col>
            </v-row>
                
            <v-divider/>
            <v-row dense class="pa-2 ma-0" cols="12">
                <span class="px-4" v-if="selected.length>0">{{ selected.length }} Photo's selected</span>
                <span class="px-4" v-else>No photo's selected</span>
                <v-spacer></v-spacer>
                <span :style="{ color: 'red' }" v-if="confirmCounter > 0">Press "confirm copy" to confirm copy of the Photo's ({{ confirmCounter }})</span>
                <span :style="{ color: 'red' }" v-else>{{ message }}</span>
            </v-row>
            <v-divider/>
            </v-form>
            <v-card-actions>
                <v-btn color="primary" small @click="selectAll()">Select All</v-btn>
                <v-btn color="primary" small @click="clearAll()">Clear selection</v-btn>
                <v-spacer/>
                <v-btn class="warning mr-3" small @click="bulkCopy()" :disabled="!copyHsftValid">Copy Photo's</v-btn>
                <v-btn color="primary" small @click="closeDialog()">Close</v-btn>
            </v-card-actions>
        
        </v-card>
    </v-dialog>
</template>

<script>
    // import { bus } from "../../../main";

    export default {
            components: {
        },
        data() { 
            return {
                dialog: false,
                copyHsftValid: false,
                confirmTimer: null,
                confirmCounter: 0,
                fttg_nrKeuzes: [],
                hsft: {},
                hsft_array: [],
                huis: {},
                selected: [],
                message: "",
                delCounter: 0,
                to_huis_code: "",
                to_huis_code_checks: [
                    v => !!v || 'Accommodation code is required',
                ],
                selected_checks: [
                    v => (v || '').length > 0 || 'Choose at least 1 photo to copy',
                ],
                items: [],
                isLoading: false,
                model: null,
                search: null,
            }
        },
        computed: {
            reactivePhotoArray: function () {
                return this.hsft_array.filter(() => {
                    return true;
                });
            }
        },
        watch: {
            search (val) {
                this.isLoading = true
                if (val.length >= 3) {
                    this.$axios
                        .post("ares/json/ares/huis/hsab/searchHuis.p", {
                            header: {
                                token: this.$session.get("ARES"),
                                clientSessionId: this.$session.id(),
                                request: "searchHuis"
                            },
                            searchHuis: {
                                huis_code: val
                            }
                        })
                        .then(res => {
                            if (res.data.error) {
                                console.log(res.data.error);
                            } else {
                                this.items = res.data.searchHuis.huizen;
                            }
                        })
                        .finally(() => {
                            this.isLoading = false
                        });
                    }
                else {
                    this.isLoading = false
                }
            }
        },
        methods: {
            open(huis) {
                this.huis = huis;
                this.message = "";
                this.selected = [];
                this.dialog = true;
            },
            selectAll() {
                this.selected = [];
                for (let i=0; i < this.huis.hsft.length; i++) {
                    this.selected.push(this.huis.hsft[i].hsft_encrid);
                }            
            },
            clearAll() {
                this.selected = [];          
            },
            closeDialog() {
                // for (let i=0; i < this.selected.length; i++) {
                //     alert(this.selected[i]);
                // }     
                this.$refs.copyHsft.reset();       
                this.dialog = false;
            },
            copyHsftConfirmCountdown() {
                this.confirmCounter -= 1;
                if (this.confirmCounter <= 0) {
                    clearInterval(this.confirmTimer);
                }
            },
            copyHsftConfirm() {
                this.confirmCounter = 5;
                this.confirmTimer = setInterval(this.copyHsftConfirmCountdown, 1000);
            },
            remove(item){
                console.log(item)
                this.to_huis_code = "";
            },
            bulkCopy() {
                this.confirmCounter = 0;
                //clearInterval(this.confirmTimer);
                this.message = "Please wait: Copying photo's to " + this.to_huis_code;
                console.log(this.to_huis_code , this.selected)
                this.$axios.post("ares/json/ares/huis/hsft/copyHsft.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "copyHsft"
                    },
                    copyHsft: {
                        hsft_encrids: this.selected,
                        to_huis_code: this.to_huis_code
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "warning"
                        });
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.copyHsft.text,
                            color: res.data.copyHsft.color
                        });
                        // if (res.data.copyHsft.color == "success") { 
                        //     bus.$emit("closeDialog", "reload");
                        // }
                        this.$emit("updateData");
                        this.dialog = false;
                    }
                    this.message = "";
                })
                
            },
        }
    }
</script>

<style scoped>
    .flex{
        display: flex;
        flex-direction: row;
    }
    .scrollable {
        max-height: 600px;
        overflow-x: hidden;
        overflow-y: auto;
    }
</style>
